import { Component } from '@angular/core';
import { FreightDetailComponent } from './freight-detail/freight-detail.component';
import {MatDialog, MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import { CopyFromPopupComponent } from './copy-from-popup/copy-from-popup.component';


@Component({
  selector: 'app-sales-order',
  templateUrl: './sales-order.component.html',
  styleUrls: ['./sales-order.component.css']
})
export class SalesOrderComponent {

  displayedColumns: string[] = ['item_detail', 'unit_qty', 'warehouse_detail',
    'delivery_date', 'discount', 'tax', 'amount'];
  dataSource: any[] = [{

  }];
  
  
  constructor(public dialog: MatDialog) {}

  openDialog(): void {
    this.dialog.open(FreightDetailComponent, {
      // width: '250px'
    });
  }
  openDialog1(): void {
    this.dialog.open(CopyFromPopupComponent, {
      // width: '250px'
    });
  }

}
